export const aboutPage = "/about";
